import { reactive } from 'vue';

export type EditWaypointModalWaypoint = {
  type?: string;
  city?: string;
  country?: string;
  countryCode?: string;
  name?: string;
  notes?: string;
  latitude?: number;
  longitude?: number;
  coords?: [number, number] | null;
  verified?: boolean;
  inspectionRequired?: boolean;
  inspectionReasons?: string[];
  dateCreated?: unknown;
  dateModified?: unknown;
  [key: string]: unknown;
};

export type EditWaypointModalSavePayload = {
  type: string;
  name: string;
  city?: string;
  country?: string;
  countryCode?: string;
  notes?: string;
  coords: [number, number];
};

export type EditWaypointModalOpenOptions = {
  waypointId: string;
  shipmentId?: string | null;
  waypoint?: EditWaypointModalWaypoint | null;
  onSave: (payload: EditWaypointModalSavePayload) => void | Promise<void>;
};

export type EditWaypointModalState = {
  open: boolean;
  saving: boolean;
  error: string | null;
  shipmentId: string | null;
  waypointId: string | null;
  /** Increments on every open so the form always re-hydrates, even for the same waypoint. */
  openCount: number;
  waypoint: EditWaypointModalWaypoint | null;
  onSave: ((payload: EditWaypointModalSavePayload) => void | Promise<void>) | null;
};

export type EditWaypointModalApi = {
  open: (options: EditWaypointModalOpenOptions) => void;
  close: () => void;
  isOpen: () => boolean;
};

declare global {
  interface Window {
    JidokaEditWaypointModal?: EditWaypointModalApi;
  }
}

const state = reactive<EditWaypointModalState>({
  open: false,
  saving: false,
  error: null,
  shipmentId: null,
  waypointId: null,
  openCount: 0,
  waypoint: null,
  onSave: null
});

export function getEditWaypointModalState(): EditWaypointModalState {
  return state;
}

export function openEditWaypointModal(options: EditWaypointModalOpenOptions): void {
  state.shipmentId = options.shipmentId || null;
  state.waypointId = options.waypointId;
  state.waypoint = options.waypoint ? { ...options.waypoint } : null;
  state.onSave = options.onSave;
  state.error = null;
  state.saving = false;
  state.openCount += 1;
  state.open = true;
}

export function closeEditWaypointModal(): void {
  state.open = false;
  state.saving = false;
  state.error = null;
  state.shipmentId = null;
  state.waypointId = null;
  state.waypoint = null;
  state.onSave = null;
}

export function registerEditWaypointModalApi(): void {
  window.JidokaEditWaypointModal = {
    open: openEditWaypointModal,
    close: closeEditWaypointModal,
    isOpen: () => state.open
  };
}

export function unregisterEditWaypointModalApi(): void {
  if (window.JidokaEditWaypointModal) {
    delete window.JidokaEditWaypointModal;
  }
}
